import React, { PureComponent } from 'react';
import { Icon, Skeleton } from 'antd';
import clsx from 'clsx';
import { map, isEmpty, round, get } from 'lodash';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { renderNotices } from '../../../../Common/components/Attentions';
import { Link } from '../../../../../system/routing';
import { getVar } from '../../../../../system/support/helpers';

import { ReactComponent as IconExport } from './../../../../../resources/images/Iconremove.svg';

class PackageInfo extends PureComponent {
    render() {
        const { packageInfo } = this.props;

        return packageInfo.scanning ? this.renderLoading() : this.renderBag(packageInfo);
    }

    renderLoading = () => {
        return (
            <tbody>
                <tr>
                    <td colSpan={4}>
                        <Skeleton active paragraph={{ rows: 0 }} className="askeleton-item-table" />
                    </td>
                </tr>
            </tbody>
        );
    };

    renderBag = packageInfo => {
        const { scrollTable, t, onRemove } = this.props;
        const messages = packageInfo.error || packageInfo.warning || packageInfo.warnings;
        const notices = getVar(packageInfo, 'notices.text', []);
        const weight = getVar(packageInfo, 'package.weight_net')
        const volume = getVar(packageInfo, 'package.volume')
        return (
            <tbody className={clsx({
                'error': packageInfo.error,
                'warning': !packageInfo.error && (packageInfo.warning || packageInfo.warnings || notices.length)
            })}>
                <tr className="data">
                    <td>{getVar(packageInfo, 'code')}</td>
                    <td>
                        <Link
                            isNewTab
                            params={{
                                id: getVar(packageInfo, 'package.code')
                            }}
                            to="packages.detail"
                        >
                            {getVar(packageInfo, 'package.code')}
                        </Link>
                    </td>
                    <td>{isEmpty(get(packageInfo, "package", {})) ? "" : t('package')}</td>
                    <td>{weight ? weight + "(kg)": '---'}</td>
                    <td>{volume ? round(volume * 1000000, 3) + " (cm3)" : "---"}</td>
                    <td className={clsx('sticky-right', {
                        'box-shadow': scrollTable
                    })}>
                        <div className="gflex gjustify-end">
                            <span className="action-remove">
                                {packageInfo.error ? (
                                    <Icon type="close" onClick={onRemove} />
                                ) : (
                                    <IconExport onClick={onRemove} />
                                )}
                            </span>
                        </div>
                    </td>
                </tr>

                {messages || notices.length ? (
                    <tr className="message">
                        <td colSpan="6">
                            {map(messages, (message, index) => (
                                <p className="mb-2 a-text--black-45" key={index}>
                                    <Icon type='info-circle'
                                        theme="filled"
                                        className={clsx('mr-2', {
                                            'a-text--red': packageInfo.error,
                                            'a-text--orange': !packageInfo.error && (packageInfo.warning || packageInfo.warnings)
                                        })}
                                    />
                                    {t(`scan:warning.${message.code || message}`)}
                                </p>
                            ))}

                            {renderNotices(notices)}
                        </td>
                    </tr>
                ) : null}
            </tbody>
        );
    };
}

PackageInfo.defaultProps = {
    onRemove: () => {
    }
};

PackageInfo.propTypes = {
    onRemove: PropTypes.func
};

export default withTranslation()(PackageInfo);
